import * as Immutable from 'immutable'
import * as React from 'react'
import { IntlProvider } from 'react-intl'
import {
  Action,
  any,
  async,
  AsyncState,
  fromJSX,
  loadingAsyncState,
  none,
  nothing,
  Option,
  some,
  stateful,
  Widget
} from 'widgets-for-react'
import { LoaderCircle } from '../../accommodations/models/loading'
import { getMerchant } from '../../api/online_payment_platform'
import { MerchantResponse } from '../../types/online_payment_platform'
import { urlToRedirect } from './onboarding'

type Props = {
  id: number
}

type State = {
  merchantResponse: AsyncState<MerchantResponse>
}

const initialState = (props: Props): State => ({
  merchantResponse: loadingAsyncState(_ => getMerchant(props.id))
})

const merchantLoader = (s0: State): Widget<Action<State>> =>
  async<MerchantResponse>()(s0.merchantResponse).map(uc => s => {
    const merchantResponse = uc(s.merchantResponse)
    return {
      ...s,
      merchantResponse
    }
  })

export class Verification extends React.Component<Props> {
  render() {
    return (
      <>
        {stateful<State>({ key: 'account_verification' })(s0 =>
          any<Action<State>>()([
            merchantLoader(s0),
            fromJSX(_ => <LoaderCircle />).never()
          ]).map(a => {
            const newState = a(s0)
            if (newState.merchantResponse.kind === 'loaded') {
              window.location.href = urlToRedirect(
                this.props,
                newState.merchantResponse.value
              )
            }
            return newState
          })
        )(initialState(this.props)).run(_ => {})}
      </>
    )
  }
}

export default (props: Props): JSX.Element => (
  <IntlProvider locale={window.Gites.locale}>
    <Verification {...props} />
  </IntlProvider>
)
